import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  scrollContent: {
    overflowY: 'auto'
  }
}))

const ScrollContent = React.forwardRef(function ScrollContent ({ children, className, maxHeight }, ref) {
  const classes = useStyles()

  return (
    <div ref={ref} className={clsx(classes.scrollContent, className)} style={{ maxHeight }}>
      {children}
    </div>
  )
})

ScrollContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default ScrollContent
